import { type Timestamp } from '../services/Timestamp';
import { type TimestampModelRange } from '../types';

export const isTimestampWithinRange = (timestamp: Timestamp, range: TimestampModelRange): boolean => {
  return (
    timestamp.toMilliseconds() >= range.from.valueInMilliseconds &&
    timestamp.toMilliseconds() <= range.to.valueInMilliseconds
  );
};
